var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowCreditNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.9,
    height: 30.187,
    viewBox: "0 0 25.9 30.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161116",
    "data-name": "Group 161116",
    transform: "translate(-510.01 -400.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161107",
    "data-name": "Group 161107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M14.69,29.47a17.263,17.263,0,0,1-8.34-1.28,6.149,6.149,0,0,1-2.56-1.98,3.9,3.9,0,0,1-.78-2.35V6.8A4.047,4.047,0,0,1,4.48,3.68a9.064,9.064,0,0,1,4.13-2,19.661,19.661,0,0,1,10.78.38A7.7,7.7,0,0,1,22.28,3.7a4.248,4.248,0,0,1,1.46,3.28v6.84",
    transform: "translate(507 399)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M13.33,10.3a16.868,16.868,0,0,0,4.95-.69,6.07,6.07,0,0,0,2.46-1.29,1.857,1.857,0,0,0,.29-2.61,1.986,1.986,0,0,0-.29-.29,5.239,5.239,0,0,0-1.98-1.14A16.97,16.97,0,0,0,8.4,4.14,5.66,5.66,0,0,0,5.93,5.49a1.776,1.776,0,0,0-.23,2.5,2.5,2.5,0,0,0,.23.23A6.161,6.161,0,0,0,7.65,9.3a14.889,14.889,0,0,0,5.68.99",
    transform: "translate(507 399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M5.31,10.75c0,.43.02.87,0,1.31a1.479,1.479,0,0,0,.51,1.25,7.886,7.886,0,0,0,1.49,1.06,13.59,13.59,0,0,0,7.01,1.33,2.789,2.789,0,0,0,1.12-.33,13.373,13.373,0,0,1,4.58-1.39,1.222,1.222,0,0,0,.55-.23,2.8,2.8,0,0,0,.83-2.98,17.856,17.856,0,0,1-16.08-.03",
    transform: "translate(507 399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M5.31,21.61c0,.68.02,1.3,0,1.91a2.189,2.189,0,0,0,.91,1.9,6.858,6.858,0,0,0,2.3,1.13,15.447,15.447,0,0,0,4.05.66,16.266,16.266,0,0,1-.33-1.69,17.2,17.2,0,0,1-.01-1.76,14.7,14.7,0,0,1-6.91-2.14",
    transform: "translate(507 399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M12.2,21.49c.09-1.21-.16-2.36.38-3.46a14.952,14.952,0,0,1-7.27-2.16c0,.61.04,1.15-.01,1.68a2.067,2.067,0,0,0,.95,1.93,9,9,0,0,0,3.32,1.5c.85.21,1.73.34,2.63.51",
    transform: "translate(507 399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_249",
    cx: 9.29,
    cy: 9.29,
    r: 9.29,
    transform: "translate(517.33 411.711)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-arrow-77",
    d: "M26.24,20.62a8,8,0,1,0-8,8,8,8,0,0,0,8-8Zm-11.335.674h2.67v-5.33h1.33v5.33h2.67l-3.335,4-3.335-4Z",
    transform: "translate(508.38 400.381)",
    fill: "#cf5b63"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowCreditNotificationIcon);
export default __webpack_public_path__ + "static/media/low-credit-notification-icon.53e4d58b7297eebd4875bb849f79ce51.svg";
export { ForwardRef as ReactComponent };